import React from "react";
import * as S from "./JourneyMilestone.style";
import FlorenzButton from "../../../../florenzComponents/florenzButton";

const getBadgeStyles = (type) => {
  switch (type) {
    case "pending":
      return { bg: "#F1F5F9", color: "#64748B" };
    case "pending-delayed":
      return { bg: "#F1F5F9", color: "#64748B" };
    case "completed":
      return { bg: "#ECFDF5", color: "#64748B" };
    case "completed-delayed":
      return { bg: "#ECFDF5", color: "#64748B" };
    default:
      return { bg: "#f8f9fa", color: "#8c8c8c" };
  }
};

const formatBadgeText = (text) => {
  if (text.includes("con retraso")) {
    const parts = text.split("con retraso");
    return (
      <>
        {parts[0]} <strong>con retraso</strong>
      </>
    );
  }
  return text;
};

const JourneyMilestone = ({ milestone }) => {
  const badgeStyles = getBadgeStyles(milestone.badgeType);

  return (
    <S.Container locked={milestone.locked}>
      <div className="left-col">
        {milestone.locked ? (
          <div className="icon-box lock"><i className="icon zaia-i-locked" /></div>
        ) : (
          <div className={`checkbox ${milestone.checked ? "checked" : ""}`}>
            {milestone.checked && <i className="icon zaia-i-check-1" />}
          </div>
        )}
        {/* <div className="icon-box info"><i className="icon zaia-icono-informacion-1" /></div> */}
        <FlorenzButton
          typeStyle={"outline"}
          icon="zaia-i-info"
          size="s"
          iconSize={"15px"}
        />
        <div className="title">{milestone.title}</div>
      </div>

      <div className="date-col">
        {milestone.primaryDateText && (
          <>
            <div className="date-text">{milestone.primaryDateText}</div>
            <div className="date-label">{milestone.primaryDateLabel}</div>
          </>
        )}
      </div>

      <div className="date-col secondary">
        {milestone.secondaryDateText && (
          <>
            <div className={`date-text ${milestone.isDelayed ? "delayed" : ""}`}>
              {milestone.secondaryDateText}
            </div>
            <div className="date-label">{milestone.secondaryDateLabel}</div>
          </>
        )}
      </div>

      <div className="status-col">
        <div 
          className="badge" 
          style={{ 
            backgroundColor: badgeStyles.bg, 
            color: badgeStyles.color 
          }}
        >
          {formatBadgeText(milestone.badge)}
        </div>
      </div>
    </S.Container>
  );
};

export default JourneyMilestone;
